import React from 'react'
import { useSelector } from 'react-redux'
import { getSettingsState } from '../../store/slices/selectors'

import {
  ApplicationTypeSelection,
  CountrySelection,
  FormControlWrapper,
  JobSettings,
  Roof,
  Wall,
} from './components'

const InputSection = (props) => {
  const country = useSelector((state) => getSettingsState(state).country)

  return (
    <div className="inputSectionWrapper" {...props}>
      <div className="paneHeader">
        <div className="paneHeader__staticHeading">
          <div className="d-flex justify-content-between">
            <span>Input</span>
            <CountrySelection country={country} />
          </div>
        </div>
      </div>
      <div className="inputSection">
        <div className="container-fluid p-0">
          <FormControlWrapper>
            <ApplicationTypeSelection country={country} />
            <JobSettings country={country} />
            <Wall />
            <Roof country={country} />
          </FormControlWrapper>
        </div>
      </div>
    </div>
  )
}

export default InputSection
